import React from 'react';

const HTML_DOM_Objects = () => {
  return (
    <div >
      <h1>HTML_DOM_Objects</h1>
      <p>Placeholder component for: "HTML DOM Objects"</p>
    </div>
  );
};

export default HTML_DOM_Objects;
